import { useDroppable } from '@dnd-kit/core';
import { Box } from '@mui/material';

export const EmptyDropZone = ({ id }) => {
  const { setNodeRef } = useDroppable({ id });

  return (
    <Box
      ref={setNodeRef}
      sx={{
        height: 80,
        border: '1px dashed #ccc',
        borderRadius: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#aaa',
        fontStyle: 'italic',
      }}
    >
      Arrastra aquí
    </Box>
  );
};
